import { render } from "./TextareaInput.vue?vue&type=template&id=b1cef9f8"
import script from "./TextareaInput.vue?vue&type=script&lang=js"
export * from "./TextareaInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Shared/TextareaInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1cef9f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1cef9f8', __exports__)) {
    console.log('reload')
    api.reload('b1cef9f8', __exports__)
  }
  
  module.hot.accept("./TextareaInput.vue?vue&type=template&id=b1cef9f8", () => {
    console.log('re-render')
    api.rerender('b1cef9f8', render)
  })

}


export default __exports__